import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PopUp from './../Popup/logoutPopup'
import { useDispatch } from 'react-redux';
import { useAppContext } from './../Lib/contextLib';
import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getVideo, GetUserVideo } from '../s3Func/s3Download';
import Store from './Store/store.jpg'
import './FreePlay.scss';
import Dictaphone from './Level4/Translate';
import TopicAnalyzerDemo from './Level4/ExampleUsage';


const FreePlay = (props) => {

    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const dispatch = useDispatch();
    const [levelPlay, setLevelPlay] = useState(props.level);
    const [coins, setCoins] = useState(0);
    const categories = Object.keys(freeplay.level1);

    let progressCount1 = 0;
    let progressCount2 = 0;
    let progressCount3 = 0;
    let progressCount4 = 0;
    const [progress1, setProgress1] = useState(progressCount1);
    const [progress2, setProgress2] = useState(progressCount2);
    const [progress3, setProgress3] = useState(progressCount3);
    const [progress4, setProgress4] = useState(progressCount4);
    const [level2Unlocked, setLevel2Unlocked] = useState(false);
    const [level3Unlocked, setLevel3Unlocked] = useState(false);
    const [level4Unlocked, setLevel4Unlocked] = useState(false);

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    const navigate = useNavigate();
    const coin = generateImageUrl('images/Images/Coin_Empty.png');
    const lock = generateImageUrl('images/Images/Icon_Lock_Large_white.png');

    const [favoriteAchievement, setFavoriteAchievement] = useState(lock);
    const [feelingAchievement, setFeelingAchievement] = useState(lock);
    const [listeningAchievement, setListeningAchievement] = useState(lock);
    const [friendsAchievement, setFriendsAchievement] = useState(lock);
    const [solutionAchievement, setSolutionAchievement] = useState(lock);
    const [conflictAchievement, setConflictAchievement] = useState(lock);
    const [advocacyAchievement, setAdvocacyAchievement] = useState(lock);
    const [communityAchievement, setCommunityAchievement] = useState(lock);
    const [showTopicAnalyzerDemo, setShowTopicAnalyzerDemo] = useState(false);

    const setLevel = (num) => {
        setLevelPlay(num);
        // if(num === 3){
        //     setShowTopicAnalyzerDemo(!showTopicAnalyzerDemo);
        // }
        // document.getElementsByClassName('levelButton')[0].style.display = 'block';
    }

    const navigateLevel = () => {
        switch(levelPlay){
            case 0:
                navigate("/freeplay/level1");
                break;
            case 1:
                navigate("/freeplay/level2");
                break;
            case 2:
                navigate("/freeplay/level3");
                break;
            case 3:
                navigate("/freeplay/level4");
                break;
            default:
                break;
        }
    }

    const navigateDecorate = (store = "") => {
        switch(levelPlay){
            case 0:
                navigate(`/freeplay/level1/decorate/${store}`);
                break;
            case 1:
                navigate(`/freeplay/level2/decorate/${store}`);
                break;
            case 2:
                navigate(`/freeplay/level3/decorate/${store}`);
                break;
            case 3:
                navigate(`/freeplay/level4/decorate/${store}`);
                break;
            default:
                break;
        }
    }


    const getAnimalData = (level, levelName, unlockedCount) => {
        const achievementSetters = {
            favorite: setFavoriteAchievement,
            feeling: setFeelingAchievement,
            listening: setListeningAchievement,
            friends: setFriendsAchievement,
            solution: setSolutionAchievement,
            conflict: setConflictAchievement,
            advocacy: setAdvocacyAchievement,
            community: setCommunityAchievement
        };
        if (Object.values(freeplay[level][levelName]).filter(value => value.unlocked === 1).length === unlockedCount) {
            GetUserVideo(`userfiles/${login.studentid}/${level}_${levelName}_animal.png`).then((data) => {
                fetch(data).then((response) => {
                    if (response.status === 200) {
                        // Call the corresponding setter function from the achievementSetters object
                        achievementSetters[levelName](data);
                    } else {
                        achievementSetters[levelName](lock);
                    }
                });
            });
        }
        else{
            achievementSetters[levelName](lock);
        }
    };

    useEffect(() => {
        categories.forEach(category => {
            const totalItems = Object.values(freeplay.level1[category]).length;
            const unlockedCount = Object.values(freeplay.level1[category]).filter(value => value.unlocked === 1).length;
    
            // Ensure that the unlockedCount is what you expect based on the total possible items
            if ((unlockedCount === 5 && totalItems === 5) || 
                (unlockedCount === 6 && totalItems === 6) || 
                (unlockedCount === 3 && totalItems === 3) ||
                (unlockedCount === 10 && totalItems === 10)) {
                progressCount1++;
            }
        });
        setProgress1(progressCount1)
        document.querySelectorAll('.levelImage').forEach(function(element) {
            element.style.border= '';
        })
        let element = document.getElementsByClassName('levelImage')[levelPlay]
        element.style.border= '2px solid yellow';

        const animalConfigurations = [
            { levelName: "favorite", unlockedCount: 5},
            { levelName: "feeling", unlockedCount: 6},
            { levelName: "listening", unlockedCount: 6},
            { levelName: "friends", unlockedCount: 5},
            { levelName: "solution", unlockedCount: 3},
            { levelName: "conflict", unlockedCount: 5},
            { levelName: "advocacy", unlockedCount: 5},
            { levelName: "community", unlockedCount: 10}
        ];

        if (levelPlay === 0 ) {
            setCoins(freeplay.level1Coin)
            animalConfigurations.forEach(config => {
                getAnimalData("level1", config.levelName, config.unlockedCount);
            });
        }
        else if (levelPlay === 1) {
            setCoins(freeplay.level2Coin)
            animalConfigurations.forEach(config => {
                getAnimalData("level2", config.levelName, config.unlockedCount);
            });
        }
        else if (levelPlay === 2) {
            setCoins(freeplay.level3Coin)
            animalConfigurations.forEach(config => {
                getAnimalData("level3", config.levelName, config.unlockedCount);
            });
        }
        else if (levelPlay === 3) {
            setCoins(freeplay.level4Coin)
            animalConfigurations.forEach(config => {
                getAnimalData("level4", config.levelName, config.unlockedCount);
            });
        }
    }, [levelPlay]);
    useEffect(() => {
        if(level2Unlocked){
            categories.forEach(category => {
                const totalItems = Object.values(freeplay.level2[category]).length;
                const unlockedCount = Object.values(freeplay.level2[category]).filter(value => value.unlocked === 1).length;
        
                // Ensure that the unlockedCount is what you expect based on the total possible items
                if ((unlockedCount === 5 && totalItems === 5) || 
                    (unlockedCount === 6 && totalItems === 6) || 
                    (unlockedCount === 3 && totalItems === 3) ||
                    (unlockedCount === 10 && totalItems === 10)) {
                    progressCount2++;
                }
            });
            setProgress2(progressCount2)
        }
    }, [level2Unlocked]);

    useEffect(() => {
        if(progress1 === 8){
            if(!freeplay.level2){
                dispatch({
                    type: 'SET_FREEPLAY_LEVEL2_INITIALSTATE',
                    payload: null,
                });
            }
            setLevel2Unlocked(true);
        }
    }, [progress1]);

    useEffect(() => {
        if(progress2 === 8){
            if(!freeplay.level3){
                dispatch({
                    type: 'SET_FREEPLAY_LEVEL3_INITIALSTATE',
                    payload: null,
                });
            }  
            setLevel3Unlocked(true);      
        }
    }, [progress2]);

    useEffect(() => {
        if(progress3 === 8){
            dispatch({
                type: 'SET_FREEPLAY_LEVEL4_INITIALSTATE',
                payload: null,
            });
            setLevel4Unlocked(true);
        }
    }, [progress3]);

    useEffect(() => {
        if(level3Unlocked){
            categories.forEach(category => {
                const totalItems = Object.values(freeplay.level3[category]).length;
                const unlockedCount = Object.values(freeplay.level3[category]).filter(value => value.unlocked === 1).length;
        
                // Ensure that the unlockedCount is what you expect based on the total possible items
                if ((unlockedCount === 5 && totalItems === 5) || 
                    (unlockedCount === 6 && totalItems === 6) || 
                    (unlockedCount === 3 && totalItems === 3) ||
                    (unlockedCount === 10 && totalItems === 10)) {
                    progressCount3++;
                }
            });
            setProgress3(progressCount3)
        }
    }, [level3Unlocked]);

    useEffect(() => {
        if(level4Unlocked){
            categories.forEach(category => {
                const totalItems = Object.values(freeplay.level4[category]).length;
                const unlockedCount = Object.values(freeplay.level4[category]).filter(value => value.unlocked === 1).length;
        
                // Ensure that the unlockedCount is what you expect based on the total possible items
                if ((unlockedCount === 5 && totalItems === 5) || 
                    (unlockedCount === 6 && totalItems === 6) || 
                    (unlockedCount === 3 && totalItems === 3) ||
                    (unlockedCount === 10 && totalItems === 10)) {
                    progressCount4++;
                }
            });
            setProgress4(progressCount4)
        }
    }, [level4Unlocked]);

    return (
        <div className='freePlayBody' style={{ overflow: "scroll" }}>
            <header>
                <div className='actions'>
                    <h3><a onClick={() => {navigate("/unitPage")}}>&#60; Units</a></h3>
                </div>
                <h1>Free Play</h1>

                <div className='coins'>
                    <img src={coin} alt='crab Icon'/>
                    {coins < 10 && <div className='coin1'>{coins}</div>}
                    {coins >= 10 && coins < 100 && <div className='coin10'>{coins}</div>}
                    {coins >= 100 && <div className='coin100'>{coins}</div>}
                </div>
            </header>
            <div className='level'>
                <Container>
                    <Row xs={4} md={4} lg={4}>
                        <Col> 
                            <div className='levelOption' onClick={() => {setLevel(0)}}>
                                <div className='levelLable'>Level 1</div>
                                <img alt='level 1' className='levelImage' src={generateImageUrl('images/Module1Images/U1M1_Background_Landscape.png')} />
                                <div className='levelLable'>{progress1} / 8</div>
                            </div>
                        </Col>
                        <Col> 
                            <div className='levelOption' id={level2Unlocked ? "" : "disabled"} onClick={() => {setLevel(1)}}>
                                {!level2Unlocked && (
                                    <img className='lock' src={lock} alt='Lock' />
                                )}
                                <div className='levelLable'>Level 2</div>
                                <img alt='level 2' className='levelImage' src={generateImageUrl('images/Module6Images/Day+Scene+Nav+Template+-+ML+%E2%80%93+2.png')} />
                                {level2Unlocked && <div className='levelLable'>{progress2} / 8</div>}
                            </div>
                        </Col>                    
                        <Col> 
                            <div className='levelOption' id={false ? "" : "disabled"} onClick={() => {setLevel(2)}}>
                                <div className="coming-soon-banner">COMING SOON</div>
                                {!false && (
                                    <img className='lock' src={lock} alt='Lock' />
                                )}
                                <div className='levelLable'>Level 3</div>
                                <img alt='level 3' className='levelImage' src={generateImageUrl('images/Module3Images/U1M3_DayScene_Landscape.png')} />
                            </div>
                        </Col>
                        {/* <Col> 
                            <div className='levelOption' id={level3Unlocked ? "" : "disabled"} onClick={() => {setLevel(2)}}>
                                {!level3Unlocked && (
                                    <img className='lock' src={lock} alt='Lock' />
                                )}
                                <div className='levelLable'>Level 3</div>
                                <img alt='level 3' className='levelImage' src={generateImageUrl('images/Module3Images/U1M3_DayScene_Landscape.png')} />
                                {level3Unlocked && <div className='levelLable'>{progress3} / 8</div>}
                            </div>
                        </Col>                         */}
                        <Col> 
                            <div className='levelOption' id={level4Unlocked  ? "" : "disabled"} onClick={() => {setLevel(3)}}>
                                <div className="coming-soon-banner">COMING SOON</div>
                                {!level4Unlocked && (
                                    <img className='lock' src={lock} alt='Lock' />
                                )}
                                <div className='levelLable'>Level 4</div>
                                <img alt='level 4' className='levelImage' src={generateImageUrl('images/Module4Images/Background.png')} />   
                                {level4Unlocked && <div className='levelLable'>{progress4} / 8</div>}
                            </div>
                        </Col>             
                    </Row>
                    {/* {showTopicAnalyzerDemo && <TopicAnalyzerDemo />}     */}
                </Container>
            </div>
            <div className='levelButton'>
                        <div className='button play' onClick={() => {navigateLevel()}}>
                            <div className='text'>PLAY</div>
                        </div>                        
                        <div className='button decorate' onClick={() => {navigateDecorate()}}>
                            <div className='text'>DECORATE</div>
                        </div>
            </div>
            <div className='achievement'>
                <h1 className='header'>
                    Achievements
                </h1>
                <Container>
                    <Row xs={2} md={4} lg={4}>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Favorite Things</div>
                                 <img src={favoriteAchievement} alt='Lock' />
                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Talk about Feelings</div>
                                <img src={feelingAchievement} alt='Lock' />

                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Active Listening</div>
                                <img src={listeningAchievement} alt='Lock' />

                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Making Friends</div>
                                <img src={friendsAchievement} alt='Lock' />
                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Solutions</div>
                                <img src={solutionAchievement} alt='Lock' />
                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Resolve Conflict</div>
                                <img src={conflictAchievement} alt='Lock' />
                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Self-Advocacy</div>
                                <img src={advocacyAchievement} alt='Lock' />
                            </div>
                        </Col>
                        <Col> 
                            <div className='option'>
                                <div className='text'>Community Locations</div>
                                <img src={communityAchievement} alt='Lock' />
                            </div>
                        </Col>
    
                    </Row>
                </Container>
            </div>
            <footer>
                <img alt='store icon' className='store' src={Store} onClick={() => {navigateDecorate("store");}}/>
            </footer>
        </div>
    );
};
export default FreePlay;
